import { Identify } from '@amplitude/analytics-browser';
import * as amplitude from '@amplitude/unified';
import { initSharedLib } from '@frontend/shared/config';
import { captureException } from '@sentry/react';

import { constants } from './constants';

initSharedLib({
  // Télémétrie : l'app fournit son SDK, libs/shared n'en importe aucun en dur.
  // Ici les SDK navigateur, puisque c'est une app web. Une app native doit
  // fournir les siens (@sentry/react-native, @amplitude/analytics-react-native) :
  // les instances ne sont PAS partagées entre les deux familles.
  telemetry: {
    captureException: (error, context) => captureException(error, context),
    setUser: (userId, traits) => {
      amplitude.setUserId(userId);
      if (traits) amplitude.identify(Object.entries(traits).reduce((id, [k, v]) => id.set(k, v), new Identify()));
    },
    resetUser: () => amplitude.reset(),
  },
  isProd: constants.isProduction,
  passengerApiUrl: constants.passengerApi,
  storagePrefix: constants.storagePrefix,
  systemLocale: navigator.language,
  reloadSystem: () => window.location.reload(),
  storage: {
    setItem: (key, value) => localStorage.setItem(key, value),
    getItem: key => localStorage.getItem(key),
    removeItem: key => localStorage.removeItem(key),
  },
});
